import moment from 'moment'
import find from 'lodash/find'
import findIndex from 'lodash/findIndex'
import get from 'lodash/get'

import { constants } from 'gipsy-misc'

/* utils for todolist page / teamlist page / archive page */

/*
 ** *************************************************************
 ** README (elements present in lists are tasks or events)
 **
 ** items = { today: [...], tomorrow: [...], upcoming: [...], backlog: [...] }
 ** list = today: [...]
 ** element = task or event (part of a list)
 **
 ** position = { group: 'today', index: 2, element: {...} }
 ** *************************************************************
 */

/* ************************************************************* */
/* *********** global utils (look over all reducers) *********** */
/* ************************************************************* */

export const findById = id => {
  if (!id) return null
  const state = require('store').default.getState()
  const reducers = ['todolist', 'teamlist']
  for (let reducer of reducers) {
    const element = findElementInItemsById(state[reducer].items, id)
    if (element) {
      return element
    }
  }
  return null
}

export const findPositionById = id => {
  if (!id) return null
  const state = require('store').default.getState()
  const reducers = ['todolist', 'teamlist']
  for (let reducer of reducers) {
    const position = findPositionInItemsById(state[reducer].items, id)
    if (position) {
      return { ...position, list: reducer }
    }
  }
  return null
}

/* ************************************************************* */
/* ************************ items utils ************************ */
/* ************************************************************* */

export const findElementInItemsById = (items, id) => {
  if (!items || !id) {
    return null
  }
  let element = null
  for (let group in items) {
    if ((element = findInListById(items[group].list, id))) {
      return element
    }
  }
  return null
}

export const findPositionInItemsById = (items, id) => {
  if (!items || !id) {
    return null
  }
  let index = null
  for (let group in items) {
    if ((index = findIndex(items[group].list, ['id', id])) !== -1) {
      return { element: items[group].list[index], group, index }
    }
  }
  return null
}

export const findElementInItemsByPosition = (items, position = {}) => {
  return get(items, `${position.group}.list[${position.index}]`)
}

/* ************************************************************* */
/* ************************ list utils ************************* */
/* ************************************************************* */

export const findInListById = (list, id) => {
  if (!list || !id) {
    return null
  }
  let element = find(list, ['id', id])
  return element
}

/* sum all non-free list elements estimatedTime */
export const getListTotalDuration = list => {
  let total = 0

  for (let element of list) {
    if (!element || element.free) {
      continue
    }
    total += element.estimatedTime
  }

  return total
}

export const groupArchiveListByDay = list => {
  let result = {}
  const now = moment()

  for (let element of list) {
    const date = moment.parseZone(element.completionTime)
    let key = date.format('YYYY-MM-DD')
    if (now.diff(date, 'days') > constants.nbDaysToShowInArchivePage) {
      key = 'all'
    }
    result[key] = result[key] || []
    result[key].push(element)
  }

  return result
}



// WEBPACK FOOTER //
// ./src/features/list/utils.js